import Header from './components/Header.jsx';
import LeftPanel from './components/LeftPanel.jsx';
import CenterPanel from './components/CenterPanel.jsx';
import RightPanel from './components/RightPanel.jsx';
import StatusBar from './components/StatusBar.jsx';
import ProgressOverlay from './components/ProgressOverlay.jsx';
import RobotModal from './components/modals/RobotModal.jsx';
import FileListModal from './components/modals/FileListModal.jsx';
import UploadModal from './components/modals/UploadModal.jsx';
import TransformModal from './components/modals/TransformModal.jsx';
import ValidationPanel from './components/modals/ValidationPanel.jsx';
import { 
  PanelErrorBoundary, 
  VisualizerErrorBoundary, 
  ModalErrorBoundary 
} from './components/ErrorBoundary.jsx';
import { useVisualizer } from './hooks/useVisualizer.js';
import { useUIHandlers } from './hooks/useUIHandlers.js';

function App() {
  // Initialize visualizer
  useVisualizer();
  
  // Setup UI handlers
  useUIHandlers();

  return (
    <div className="flex flex-col h-screen w-screen overflow-hidden">
      <Header />
      
      <div className="flex flex-1 overflow-hidden gap-4 p-4">
        <PanelErrorBoundary panelName="Left Panel">
          <LeftPanel />
        </PanelErrorBoundary>
        <VisualizerErrorBoundary>
          <CenterPanel />
        </VisualizerErrorBoundary>
        <PanelErrorBoundary panelName="Right Panel">
          <RightPanel />
        </PanelErrorBoundary>
      </div>
      
      <StatusBar />
      
      <ProgressOverlay />
      <ModalErrorBoundary modalName="Robot Connection">
        <RobotModal />
      </ModalErrorBoundary>
      <ModalErrorBoundary modalName="File List">
        <FileListModal />
      </ModalErrorBoundary>
      <ModalErrorBoundary modalName="Upload">
        <UploadModal />
      </ModalErrorBoundary>
      <ModalErrorBoundary modalName="Transform">
        <TransformModal />
      </ModalErrorBoundary>
      <ModalErrorBoundary modalName="Validation">
        <ValidationPanel />
      </ModalErrorBoundary>
    </div>
  );
}

export default App;

